import React from "react";
import PropTypes from "prop-types";
import ModalDialog from "./ModalDialog";

class DeleteConfirmationDialog extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { id, title, content, show, onCancel, onDelete } = this.props;

        const buttons = [{
            bsStyle: "default",
            cssClass: "btn",
            onClick: () => onCancel(),
            key: "cancel",
            text: "CANCEL"
        }, {
            bsStyle: "primary",
            cssClass: "btn btn-primary",
            onClick: () => {
                onDelete();
                onCancel();
            },
            key: "delete",
            text: "DELETE"
        }];

        return (
            <ModalDialog id={id}
                title={title}
                content={content}
                buttons={buttons}
                onDocumentClose={() => onCancel()}
                show={show}/>
        );
    }
}

DeleteConfirmationDialog.propTypes = {
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired,
    onCancel: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired
};

export default DeleteConfirmationDialog;
